import { render, staticRenderFns } from "./PolicyRenewal.vue?vue&type=template&id=8e18e4f6&scoped=true"
import script from "./PolicyRenewal.vue?vue&type=script&lang=js"
export * from "./PolicyRenewal.vue?vue&type=script&lang=js"
import style0 from "./PolicyRenewal.vue?vue&type=style&index=0&id=8e18e4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e18e4f6",
  null
  
)

export default component.exports